import React from 'react'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../../utils/anchorScroll'

// import './NoAccountModal.css'

const NoAccountModal = ({ translationStore, noAccountModalStore, href, history }) => {

  const onLoginButtonClick = async () => {
    history.location.state = { redirect: history.location.pathname }
    await anchorScroll('top', '/login')
  }

  return (
    <div>
      <div id='NoAccountModal' className='md-modal'>
        <div className='md-modal__inner md-content'>
          <div className='md-modal__close'>
          <i
            className='close fas fa-times'
            style={{width: 'fit-content'}}
            onClick={() => document.querySelector('#NoAccountModal').classList.remove('md-show')}
          />
          </div>

          <div className='md-modal__header modal-header'>
            {/* <img src={translationStore.translate('header_logo_url')} alt={translationStore.translate('header_logo_alt')} /> */}
            <img src="/icons/logo.png" alt={translationStore.translate('header_logo_alt')} />
            <div className='md-modal__header__icons icons-container'>
              <i className='fas fa-shopping-cart icon' />
              <i className='fas fa-arrow-right icon' />
              <i className='fas fa-piggy-bank icon' />
            </div>
          </div>
          <div className='md-modal__body md-body'>
            <div className='md-modal__body__text modal-text'>
                <i className='fas fa-exclamation-triangle' />
                <p>
                  {translationStore.translate(noAccountModalStore.content)}
                </p>
              </div>
              <div>
              <div className='md-modal__body__buttons' style={{width: 'fit-content'}} onClick={() => { document.querySelector('#NoAccountModal').classList.remove('md-show') }}>
                <div className='no-underline' onClick={() => anchorScroll('#registration', '/')} >
                  <button className='button'>
                    {translationStore.translate('general_button_register')}
                  </button>
                </div>
                <span onClick={onLoginButtonClick} className='cursor-pointer'>
                  <button className='button'>
                    {translationStore.translate('general_button_login')}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a
        onClick={() => document.querySelector('#NoAccountModal').classList.remove('md-show')}
        className='md-overlay w-screen h-screen'
        target='_blank'
        href={href}
      > </a>
    </div>
  )
}

export default withRouter(inject('translationStore', 'noAccountModalStore')(observer(NoAccountModal)))



// WEBPACK FOOTER //
// ./src/components/Header/NoAccountModal/index.js